(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-blog-post"]) return;
  try {
    
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-vantura-instagram]');
    if (!button) return;
    const panel = document.getElementById(button.getAttribute('aria-controls'));
    const expanded = button.getAttribute('aria-expanded') === 'true';
    button.setAttribute('aria-expanded', String(!expanded));
    panel.hidden = expanded;
  });

  const setupVanturaSharing = () => {
    if (typeof navigator.share === 'function') {
      document.querySelectorAll('[data-vantura-native]').forEach(button => { button.hidden = false; });
    }
  };
  setupVanturaSharing();
  document.addEventListener('DOMContentLoaded', setupVanturaSharing);
  document.addEventListener('shopify:section:load', setupVanturaSharing);
  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-vantura-native]');
    if (!button) return;
    try {
      await navigator.share({title:button.dataset.title,url:button.dataset.url});
    } catch (error) {
      if (error.name !== 'AbortError') {
        button.closest('.vantura-article-share').querySelector('output').textContent = button.dataset.failure;
      }
    }
  });

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-vantura-copy]');
    if (!button) return;
    const bar = button.closest('.vantura-article-share');
    try {
      await navigator.clipboard.writeText(button.dataset.vanturaCopy);
      bar.querySelector('output').textContent = button.dataset.success;
    } catch {
      const input = bar.querySelector('input');
      input.hidden = false;
      input.focus();
      input.select();
      bar.querySelector('output').textContent = button.dataset.failure;
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
